import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { currencyFormatter } from "../../../Utils/formatUtils";

export const StockTotals = ({ costs }) => {
  return (
    <Box
      mt="1.5rem"
      background="menu.200"
      padding="0.4rem"
      fontSize="0.9em"
      textAlign="center"
    >
      <>
        <Text as="span" fontSize="1.1em" color="text.500" px={"1rem"}>
          Costos: {currencyFormatter(costs)}
        </Text>
      </>
    </Box>
  );
};
